<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <loading-component>
    <template #content>
      <div class="flex flex-col gap-4 xl:mx-60">
        <div class="flex flex-row items-center gap-4">
          <back-component></back-component>
          <span class="text-2xl font-bold text-secondary">Benutzer erstellen</span>
        </div>

        <upsert-user-component v-model="user" @save="save" />
      </div>
    </template>
  </loading-component>
</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";
import BackComponent from "@/components/BackComponent";
import UpsertUserComponent from "@/components/users/UpsertUserComponent";
import Notifications from "@auth/vue-share/utility/notifications";
import { mapStores } from "pinia";
import { useUsersStore } from "@/stores/users";
import FieldUtility from "@/utility/field.utility";
import logger from "@auth/vue-share/utility/logger";

export default {
  name: "CreateUserView",
  components: { UpsertUserComponent, BackComponent, LoadingComponent },
  data() {
    return {
      user: {
        admin: false,
        login: undefined,
        password: undefined,
        name: undefined,
        gender: undefined,
        birthday: undefined,
        street_address: undefined,
        locality: undefined,
        region: undefined,
        postal_code: undefined,
        country: undefined,
        firmation: undefined,
        mail: undefined,
        mail_verified: false,
        phone_number: undefined,
        phone_number_verified: false,
        language: "de-DE"
      }
    };
  },
  computed: {
    ...mapStores(useUsersStore)
  },
  methods: {
    save(user) {
      if (FieldUtility.isNull([
        "name",
        "login",
        "mail",
        "language"
      ], user))
        return;

      this.usersStore.createUser({
        ...this.user,
        options: {
          activation_required: !user.password
        }
      }).then((response) => {
        Notifications.success("Benutzer erfolgreich erstellen");
        this.$router.push({ path: `/users/${response.data.data._id}` });
      }).catch((error) => {
        Notifications.error("Benutzer konnte nicht erstellt werden");
        logger.error("[USER]", error);
      });
    }
  }
};
</script>

<style scoped>

</style>